import PrevButton from "../../buttons/PrevButton";
import React from "react";
import styled from "styled-components";
import ContinueButton from "../../buttons/ContinueButton";
import GoHomeButton from "../../buttons/GoHomeButton";


const TitleSection = ({
                          toggleHandler,
                          title,
                          isMax = false,
                          isMin = false,
                          canProcess
                      }) => {
    return (
        <Section>
            {/*

            <div>
                {!isMin &&
                <PrevButton
                    toggleHandler={toggleHandler}
                />
                }
            </div>

            */}
                <h1> {title} </h1>
            {/*
            <div>
                {isMax ?
                    <GoHomeButton/>
                    :
                    <ContinueButton
                        toggleHandler={toggleHandler}
                        canProcess={canProcess}
                    />
                }
            </div>
            */}
        </Section>
    )
}


const Section = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 1rem;

  h1 {
    text-align: center;
    font-size: 18px;
    width: 100%;
  }

  div {
    display: flex;
  }

  div:first-child {
    justify-content: flex-start;
  }

  div:last-child {
    justify-content: flex-end;
  }

  @media (min-width: 900px) {
    gap: unset;
  }
`

export default TitleSection;